/* Samedi storefront JS: AJAX add-to-cart, variant price, localStorage wishlist, promo */
(function () {
  var routes = window.routes || {};
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  /* 19Sep2026: the currency was hardcoded to GBP here, so the bag drawer, its line prices,
     the total and the Checkout button always printed pounds, while Shopify converts the
     prices Liquid renders on the product page for visitors outside the UK (Rest of World
     market has local currencies on). An overseas visitor saw dollars on the product page
     and pounds in the bag. /cart.js already returns amounts in the visitor's presentment
     currency, so all this needs is the active currency rather than a fixed one. */
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var loc = cur === 'GBP' ? 'en-GB' : undefined;
    try {
      return (cents / 100).toLocaleString(loc, { style: 'currency', currency: cur }).replace(/\.00$/, '');
    } catch (e) {
      return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }).replace(/\.00$/, '');
    }
  }

  /* ---------- cart count badge ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('a[data-cart-link]').forEach(function (link) {
          var badge = link.querySelector('.cart-count');
          if (cart.item_count > 0) {
            if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; link.appendChild(badge); }
            badge.textContent = cart.item_count;
          } else if (badge) { badge.remove(); }
          /* [bagaria-26sep] The accessible name is rendered server side and used to keep
             saying "Cart, 0 items" after an AJAX add, while the badge showed 1, until a full
             page load. Only the count changes; the wording matches the Liquid exactly. */
          if (link.hasAttribute('data-cart-aria')) {
            link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's'));
          }
        });
      });
  }

  /* ---------- Clarity custom events ----------
     ⚠️ 03Sep2026 I moved add to cart to AJAX (preventDefault + fetch) so the page no
     longer navigates. Clarity's auto-detected Smart Events are inferred from real
     navigations and form posts, so from that day add-to-cart and checkout stopped
     being recorded. The theme had ZERO clarity() calls, so nothing replaced the signal.

     ⚠️ 12Sep2026 I WAS WRONG ABOUT A RACE. I claimed Clarity's tag was async and could
     load after this file. It cannot: the Clarity stub is an INLINE script in <head>
     (verified, offset 35347 against </head> at 64723) so window.clarity is always
     defined before this deferred file runs. The stub also buffers into clarity.q until
     the real tag drains it. The queue below is therefore belt-and-braces, not a fix —
     the original empty dashboard was ingestion latency, not dropped events. */
  var _ceQueue = [];
  function _ceFlush() {
    if (typeof window.clarity !== 'function') return false;
    while (_ceQueue.length) {
      var it = _ceQueue.shift();
      try {
        /* tags are SESSION-scoped in Clarity, not event properties, so they must be set
           before the event and named as session facts, never as per-event data. */
        if (it.data) Object.keys(it.data).forEach(function (k) {
          window.clarity('set', k, String(it.data[k]));
        });
        window.clarity('event', it.name);
      } catch (err) { /* never let analytics break the page */ }
    }
    return true;
  }
  function ce(name, data) {
    _ceQueue.push({ name: name, data: data });
    if (_ceFlush()) return;
    var tries = 0;
    var t = setInterval(function () {
      if (_ceFlush() || ++tries > 60) clearInterval(t);   /* give up after ~18s */
    }, 300);
  }

  /* ---------- Shopify's pixel bus ----------
     A theme CANNOT call fbq or gtag directly. The Meta and Google pixels run inside
     Shopify's Web Pixels sandbox and only subscribe to Shopify's own standard events.
     `Shopify.analytics.publish` puts a custom event on that bus, and it is the only route
     that exists from theme code to an app pixel.

     ⚠️ META WILL NOT PICK THESE UP BY ITSELF. Meta's InitiateCheckout already fires from
     Shopify's STANDARD `checkout_started` when the checkout page loads, and that covers
     both the Checkout button and the wallets, because a wallet also creates a checkout. To
     get these drawer-level events into Meta specifically, a Custom Pixel has to be added in
     admin that subscribes to them and forwards them. Publishing them here is what makes
     that possible without another theme change. */
  function sa(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload || {});
      }
    } catch (err) { /* never let analytics break the page */ }
  }

  /* Product view. Clarity used to infer this from the navigation; it still sees the
     pageview, but the e-commerce event needs firing explicitly so it can be used as a
     Smart Event. Fires once per product page load. */
  if (/\/products\//.test(location.pathname) && document.querySelector('#atc-form')) {
    var _h = location.pathname.split('/products/')[1];
    ce('product_view', _h ? { last_product: _h.split(/[?#]/)[0] } : null);
  }

  /* Checkout intent. Covers both routes out of the site: the cart page button, and the
     express wallet on the product page, which skips the cart entirely and so was never
     going to be caught by a cart-page rule. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Which surface the click came from. There are now three ways out of the site, and
       telling them apart is the whole point of measuring this: the bag drawer, the full cart
       page, and the wallet on the product page. Event NAMES are deliberately unchanged so
       the Smart Events already built in the Clarity dashboard keep working.
       ⚠️ Clarity tags are SESSION scoped, not per event, so these read as session facts. */
    var surface = t.closest('.scd') ? 'drawer' : (/^\/cart/.test(location.pathname) ? 'cart_page' : 'other');
    if (t.closest('[name=checkout], .cart__checkout-button, a[href*="/checkout"]')) {
      ce('checkout_started_cart', { checkout_surface: surface });
      sa('checkout_click', { surface: surface });
    } else if (t.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) {
      /* ⚠️ Only the unbranded "Buy it now" fallback is really caught here. When the wallet
         is PayPal it renders in a CROSS-ORIGIN IFRAME, and clicks inside it produce no
         event in this document at all — nothing to listen for. Express checkout is
         therefore UNDER-reported and must be read from Shopify, not Clarity. Deliberately
         NOT matching .pdp-express: that wrapper is a full-width block whose padding and
         loading skeleton generated false positives. */
      ce('checkout_started_express', { express_surface: t.closest('.scd') ? 'drawer' : 'pdp' });
      sa('express_checkout_click', { surface: t.closest('.scd') ? 'drawer' : 'pdp' });
    }
  }, true);

  /* ---------- cart drawer ----------
     12Sep2026, second pass. The first fix navigated to /cart on add. It worked, but
     Ilyas tested it on a phone and it reads as being thrown off the product page.
     So: keep the shopper on the PDP and slide the bag in from the right, showing what
     they just added plus a Checkout button. The original problem is still solved,
     because the shopper now SEES a next step instead of a 1700ms tick.

     Built in JS from /cart.js rather than as a Liquid section, so there is nothing to
     keep in sync with the cart template and it always reflects the real cart. It
     reuses the cart page's own .cart-row / .ci-* / .qty classes, so there is one
     visual language, not two.

     No promo field and no coupon panel in here, unlike the reference screenshot:
     Samedi's promo code works by navigating through /discount, which would defeat the
     point of staying on the page, and Samedi is deliberately not discount-led. The
     full bag still has both. */
  var scd = null, scdFocusReturn = null;

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ---------- delivery estimate ----------
     Baymard guideline 543: show an estimated delivery DATE, not a speed.

     ⭐ THE RULE, set by Ilyas 12 Sep 2026, verbatim: "For weekends, say Mon/Tues. For Friday
     say Sat/Mon. For other weekdays, say the next day or day after. I do next working day."

     That is one clean rule: show the NEXT TWO DELIVERY DAYS after the order, where a
     delivery day is Monday to SATURDAY, excluding bank holidays. Saturday delivery counts,
     Sunday does not. Check it reproduces every case he gave:
       Mon -> Tue, Wed     Tue -> Wed, Thu     Wed -> Thu, Fri     Thu -> Fri, Sat
       Fri -> Sat, Mon     Sat -> Mon, Tue     Sun -> Mon, Tue

     ⛔ Do NOT reintroduce a "dispatch on the next working day" step. An earlier version added
     one and pushed every date a day late.

     Bank holidays are the official England and Wales list from gov.uk/bank-holidays.json,
     fetched 12 Sep 2026. ⚠️ EXTEND THIS LIST before Jan 2028 or the estimate drifts
     optimistic around Christmas. */
  /* [b8-29sep] FALLBACK LIST, England and Wales 2026 and 2027, copied from
     https://www.gov.uk/bank-holidays.json on 29 Sep 2026 (not from memory). The live file is
     fetched below and cached, so later years arrive on their own; this list only covers a
     failed fetch. */
  var SCD_BANK_HOLIDAYS = [
    '2026-01-01', '2026-04-03', '2026-04-06', '2026-05-04', '2026-05-25', '2026-08-31',
    '2026-12-25', '2026-12-28', '2027-01-01', '2027-03-26', '2027-03-29',
    '2027-05-03', '2027-05-31', '2027-08-30', '2027-12-27', '2027-12-28'
  ];
  /* [b8-29sep] The official list, cached for 7 days. Every storage call is wrapped: a private
     window or blocked storage must never break the page. */
  var SCD_BH_KEY = 'samedi_bh_ew_v1';
  function scdMergeHolidays(list) {
    (list || []).forEach(function (d) { if (SCD_BANK_HOLIDAYS.indexOf(d) === -1) SCD_BANK_HOLIDAYS.push(d); });
  }
  try {
    var bhc = JSON.parse(localStorage.getItem(SCD_BH_KEY) || 'null');
    if (bhc && bhc.d && bhc.t && (Date.now() - bhc.t) < 7 * 864e5) scdMergeHolidays(bhc.d);
  } catch (e) {}
  function scdFetchHolidays(done) {
    try {
      fetch('https://www.gov.uk/bank-holidays.json').then(function (r) { return r.json(); }).then(function (j) {
        var d = ((j && j['england-and-wales'] && j['england-and-wales'].events) || []).map(function (e) { return e.date; });
        if (!d.length) return;
        scdMergeHolidays(d);
        try { localStorage.setItem(SCD_BH_KEY, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
        if (done) done();
      }).catch(function () {});
    } catch (e) {}
  }
  /* [b8-29sep] UK WALL-CLOCK TIME, whatever the visitor's own time zone. Returns a Date whose
     local fields (year, month, day, hour) read as the time in London, so the day and cutoff
     tests below are UK tests. Falls back to the browser clock if Intl cannot do time zones. */
  function scdUkNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
    } catch (e) { return new Date(); }
  }

  /* ⭐ [arrival-26sep] SATURDAY IS NO LONGER A DELIVERY DAY. Ilyas, 26 Sep: show the next day's
     date "unless its a saturday". The old rule counted Saturday (recorded in the 25 Sep log as
     "Mon to Sat, Saturday counts and Sunday does not"); this supersedes it.
     ⚠️ Bank holidays are already excluded and the list below was re-checked against
     gov.uk/bank-holidays.json on 26 Sep 2026: it matches England and Wales exactly to the end
     of 2027. ⛔ Never write these dates from memory, fetch them. Easter moves. */
  function scdIsDeliveryDay(d) {
    if (d.getDay() === 0) return false;            /* no Sunday delivery */
    if (d.getDay() === 6) return false;            /* no Saturday delivery */
    var iso = d.getFullYear() + '-' +
      ('0' + (d.getMonth() + 1)).slice(-2) + '-' +
      ('0' + d.getDate()).slice(-2);
    return SCD_BANK_HOLIDAYS.indexOf(iso) === -1;
  }

  function scdNextDeliveryDay(from) {
    var out = new Date(from.getTime());
    var guard = 0;
    do {
      out.setDate(out.getDate() + 1);
      guard++;
    } while (!scdIsDeliveryDay(out) && guard < 30);
    return out;
  }

  /* ⚠️ THE DISPATCH CUTOFF. An order placed at 11pm cannot realistically be posted that day, so
     after this hour the date shown rolls on by one delivery day. 14 means 2pm.
     ⛔ THIS IS A BUSINESS RULE, NOT A MEASUREMENT. Set to 2pm by Ilyas on 29 Sep (was a 3pm default) and
     it should still match the real Royal Mail collection or drop-off time.
     One number to change. */
  var SCD_CUTOFF_HOUR = 15; /* [cut3pm-29sep] Ilyas 29 Sep evening: "change it to 3pm across the site" (was 14, 2pm). Drives the product page line, the 2pm/3pm pill and the bag. */
  /* [b8-29sep] The words for the cutoff, built from the same number: 15 -> "3pm", 14 -> "2pm". */
  function scdCutoffLabel() {
    var h = SCD_CUTOFF_HOUR % 12 || 12;
    return h + (SCD_CUTOFF_HOUR < 12 ? 'am' : 'pm');
  }
  /* [b8-29sep] The one date both lines print. Before the cutoff (UK time): the next delivery day.
     From the cutoff on: the delivery day after that. */
  /* [dispatch-5oct] POSTING DAYS. Ilyas 5 Oct: he posts Monday to Saturday, always Royal Mail Tracked 24
     (aim: next working day, delivered Mon to Sat; Sunday only in some areas, so never promised). The old
     rule assumed every day after an order was a posting day, so a Saturday-after-3pm or Sunday order was
     promised MONDAY when it is not posted until Monday and arrives TUESDAY. Now: post today if it is a
     posting day and before the cutoff, otherwise the next posting day; arrival = the next delivery day
     after posting. Saturday stays OUT of the delivery days on purpose (26 Sep rule, and Shopify's checkout
     counts business days only), so Friday orders still show Monday: an under-promise, never an over-promise. */
  function scdIsPostingDay(d) {
    if (d.getDay() === 0) return false;            /* no posting on Sunday */
    var iso = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    return SCD_BANK_HOLIDAYS.indexOf(iso) === -1;  /* no posting on bank holidays */
  }
  function scdArrivalDate() {
    var now = scdUkNow();
    var post = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (!(scdIsPostingDay(post) && now.getHours() < SCD_CUTOFF_HOUR)) {
      var guard = 0;
      do { post.setDate(post.getDate() + 1); guard++; } while (!scdIsPostingDay(post) && guard < 30);
    }
    return scdNextDeliveryDay(post);
  }

  /* ⭐ [arrival-26sep] THE BAG AND THE PRODUCT PAGE NOW NAME A DATE.
     Ilyas, 26 Sep: "Fix the delivery so it shows next days date unless its a saturday." He posts
     Royal Mail Tracked 24 through Shopify.
     ⚠️ THE DATE WAS ALREADY BEING CALCULATED HERE AND THEN THROWN AWAY. Both the try branch and
     the catch returned the same fixed string, so `first`, `second` and `fmt` were dead code. The
     machinery was right, it simply was not printed.
     Reads, for example, "Order now for delivery Tue 29 Sep".
     ⚠️ Still one line, still bold on "Order now", so nothing about the layout moves.
     ⛔ The fallback keeps the old wording rather than a wrong date: if anything throws, a vague
     true statement beats a confident false one. */
  /* [datefix-30sep] OUR OWN DAY AND MONTH NAMES. toLocaleDateString printed "30 Sept" in Chrome
     and "30 Sep" in Safari (Ilyas's iPhone, 30 Sep). The Date here already holds UK wall-clock
     fields (scdUkNow), so reading getDay/getDate/getMonth is correct in every browser. */
  var SCD_DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var SCD_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function scdFmtDate(d) {
    return SCD_DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + SCD_MONTHS[d.getMonth()];
  }
  function scdArrivalLine() {
    try {
      var day = scdArrivalDate();
      var fmt = scdFmtDate(day);
      if (!fmt) throw new Error('no date');
      return '<b>Order now</b> for delivery ' + fmt;
    } catch (err) {
      /* never let a date bug break the bag */
      return '<b>Order now</b> for next day delivery';
    }
  }

  /* [b8-29sep] The product page urgency line, Ilyas 29 Sep: "Order before 3pm for delivery Wed 30 Sep".
     Same date as the bag (scdArrivalDate), same cutoff constant, so they cannot disagree. */
  /* [shippill-29sep] For the product page's 2pm pill: true only when an order placed now arrives
     tomorrow, from the same cutoff, UK clock and delivery days as every other date on the site. */
  window.samediCutoffLabel = scdCutoffLabel;
  window.samediShipsNextDay = function () {
    try {
      var now = scdUkNow();
      if (now.getHours() >= SCD_CUTOFF_HOUR) return false;
      var t = new Date(now.getTime()); t.setDate(t.getDate() + 1);
      var a = scdArrivalDate();
      return a.getFullYear() === t.getFullYear() && a.getMonth() === t.getMonth() && a.getDate() === t.getDate();
    } catch (e) { return false; }
  };

  function scdUrgencyLine() {
    try {
      var fmt = scdFmtDate(scdArrivalDate());
      if (!fmt) throw new Error('no date');
      return 'Order before <b>' + scdCutoffLabel() + '</b> for delivery <b>' + fmt + '</b>';
    } catch (err) {
      return 'Order today for next day delivery';
    }
  }

  function scdThumb(item) {
    var u = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!u) return '';
    u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=228';
    return '<img src="' + esc(u) + '" alt="" width="76" height="76" loading="lazy">';
  }

  /* 15Sep2026, approved by Ilyas: a display-only "Gift box" row under the line items.
     It is NOT a cart line: no link, no quantity, no Remove, nothing posted to /cart, so
     item_count, the total and checkout are untouched.
     The image is the packaging shot from every product gallery (pkg-v5-studio-flat.jpg),
     exposed as window.samediPackImg by layout/theme.liquid. If that URL is missing the row
     is skipped entirely rather than rendered without its image: an empty div computes to
     display:none on this storefront, and a half-built row would look broken. */
  function scdPackRow() {
    var u = window.samediPackImg;
    if (!u || typeof u !== 'string') return '';
    return '<div class="cart-row cart-row--pack">' +
      '<div class="ci-img ph"><img src="' + esc(u) + '" alt="" width="76" height="76" loading="lazy"></div>' +
      '<div class="ci-info">' +
        '<div class="ci-top">' +
          '<div>' +
            '<div class="ci-name">Gift box</div>' +
            '<div class="ci-meta">Pouch, polishing cloth and care card</div>' +
          '</div>' +
          '<div class="ci-price">Included</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function scdBuild() {
    if (scd) return scd;
    if (!document.body) return null;
    scd = document.createElement('div');
    scd.className = 'scd';
    scd.hidden = true;
    /* No separate scrim element on purpose. An empty <div> scrim computed to
       display:none on this storefront, so tap-outside-to-close silently did
       nothing: something in the loaded CSS hides empty divs and outranks a single
       class selector. Verified in the browser: matches('div:empty') was true, and
       giving the div a child flipped computed display from none to block. The
       backdrop now lives on .scd itself, which always has children, so the bug
       cannot come back. Closing on backdrop tap is handled by geometry below. */
    scd.innerHTML =
      '<aside class="scd-panel" role="dialog" aria-modal="true" aria-label="Your bag">' +
        '<header class="scd-head">' +
          '<h2 class="scd-title">Your bag <span data-scd-count></span></h2>' +
          '<button type="button" class="scd-x" data-scd-close aria-label="Close bag">&times;</button>' +
        '</header>' +
        '<div class="scd-body" data-scd-body></div>' +
        /* One bottom block, three containers. scdRender rewrites .scd-foot and
           .scd-tail on every change but NEVER .scd-xpay. The Shopify wallet element
           installs a PerformanceObserver in connectedCallback and keeps itself in sync
           with the cart, so re-creating it on every quantity tap would re-initialise it,
           flash a skeleton and cost a round trip for nothing. */
        '<div class="scd-bottom">' +
          '<div class="scd-foot" data-scd-foot></div>' +
          '<div class="scd-xpay" data-scd-xpay></div>' +
          '<div class="scd-tail" data-scd-tail></div>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(scd);

    scd.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-scd-close]')) { scdClose(); return; }
      var q = t.closest('[data-scd-line]');
      if (q) {
        e.preventDefault();
        scdChange(q.getAttribute('data-scd-line'), q.getAttribute('data-scd-qty'), q);
        return;
      }
      /* tapped the darkened strip of page beside the panel */
      if (!t.closest('.scd-panel')) scdClose();
    });
    return scd;
  }

  function scdRender(cart) {
    if (!scd) return;
    var count = scd.querySelector('[data-scd-count]');
    var body = scd.querySelector('[data-scd-body]');
    var foot = scd.querySelector('[data-scd-foot]');
    var tail = scd.querySelector('[data-scd-tail]');
    var xpay = scd.querySelector('[data-scd-xpay]');
    var n = cart.item_count || 0;

    count.textContent = n ? '· ' + n + ' item' + (n === 1 ? '' : 's') : '';

    if (!n) {
      body.innerHTML = '<p class="scd-empty">Your bag is empty.</p>';
      foot.innerHTML = '<a class="btn btn-primary btn-block" href="/collections/mens-bracelets">Shop the Classics</a>';
      tail.innerHTML = '';
      /* no cart, so no wallets: Shopify's element has nothing to check out */
      xpay.innerHTML = '';
      xpay.classList.remove('is-loading');
      return;
    }

    body.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? esc(item.variant_title) + ' · ' : '';
      /* [sm-28sep] Classics titles now carry the width ("Atlas Figaro Bracelet 5mm"), so the width is
         dropped from this line when the title already states it, and the length prints as the size:
         "M · 20cm · Solid 925". A bracelet with a Width option and no Length option is a 20cm (M
         only) piece. Everything else (rings, anything without a Width option) prints as before.
         ⚠️ Same rule as `ci-meta` in sections/samedi-cart.liquid: change both together. */
      var ow = item.options_with_values || [], wv = '', lv = '', hasW = false;
      ow.forEach(function (o) {
        var nm = (o.name || '').toLowerCase().trim();
        if (nm === 'width') { hasW = true; wv = o.value; } else if (nm === 'length') { lv = o.value; }
      });
      if (hasW) {
        /* [onesize-4oct] `|| !lv` used to label a product with NO Length option at all as "M", so a
           one length 20cm bracelet sat in the bag calling itself a size it does not come in.
           The cart drawer is built from /cart.js, which carries no metafields, so there is no way to
           read the real length here. It therefore prints NOTHING rather than guessing a size.
           The cart PAGE (sections/samedi-cart.liquid) can see custom.spec_length and does print the
           real length there. Neither says "M" any more. */
        var sz = lv === '18cm' ? 'S' : (lv === '20cm' ? 'M' : (lv || '')); /* [sonly-29sep] size letter only; cm stays in the size guide */
        var keepW = wv && (item.product_title || '').indexOf(wv) === -1;
        var bits = [];
        if (keepW) bits.push(wv);
        if (sz) bits.push(sz);
        variant = bits.length ? esc(bits.join(' · ')) + ' · ' : '';
      }
      return '<div class="cart-row">' +
        '<a href="' + esc(item.url) + '" class="ci-img ph">' + scdThumb(item) + '</a>' +
        '<div class="ci-info">' +
          '<div class="ci-top">' +
            '<div>' +
              '<a href="' + esc(item.url) + '" class="ci-name">' + esc(item.product_title) + '</a>' +
              '<div class="ci-meta">' + variant + 'Solid 925</div>' +
            '</div>' +
            /* [twopiece-1nov] price before the automatic two-piece saving, which shows once, as its own row above TOTAL. Undo: back to money(item.final_line_price). */
            '<div class="ci-price">' + money(window.samediTwoPiece && window.samediTwoPiece.linePrice ? window.samediTwoPiece.linePrice(item) : item.final_line_price) + '</div>' +
          '</div>' +
          '<div class="ci-bottom">' +
            '<div class="qty">' +
              /* At quantity 1 the minus button would post quantity=0 and wipe the line
                 with no confirmation and no undo, then the footer would swap to the empty
                 state. On a phone that is one fat-finger away from losing the selection,
                 so it is disabled instead. Remove is still there and is explicit. */
              '<button type="button" aria-label="Decrease quantity" data-scd-line="' + line + '" data-scd-qty="' + (item.quantity - 1) + '"' + (item.quantity < 2 ? ' disabled' : '') + '>−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" aria-label="Increase quantity" data-scd-line="' + line + '" data-scd-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button type="button" class="ci-remove" data-scd-line="' + line + '" data-scd-qty="0">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('') + scdPackRow();
    /* [twopiece-1nov] two-piece offer block under the gift box row (snippets/samedi-twopiece.liquid). Undo: delete this line. */
    if (window.samediTwoPiece) { try { window.samediTwoPiece.render(cart, body); } catch (e) {} }

    /* ⛔ 12Sep2026: a four line trust list used to sit here, filling the gap under the
       items. Ilyas: "This trust lines look shit, remove them." Removed. The gap is back and
       that is fine, the footer is bottom anchored for thumb reach either way.
       ⛔ Do not re-add reassurance copy to the bag body. The material, length and returns
       terms are all on the product page, which is where the shopper reads them.
       15Sep2026: the "Gift box" row added just above by scdPackRow() is NOT that trust list
       coming back. It is a display-only line item Ilyas approved: every order includes the
       box, pouch, polishing cloth and care card, shown with its image and "Included" where a
       price would be. It is not a cart line, has no controls and changes no counts. */

    /* "Subtotal" implies charges still to come, which is the exact fear to avoid here:
       unexpected extra cost is the best-evidenced abandonment cause there is, at 40% in
       Baymard's data. So the label is TOTAL and the note says plainly that nothing more
       gets added.
       ⚠️ NOT "Tax included", which the full bag page says: Samedi is not VAT registered,
       so there is no output VAT to include and the claim would be wrong. */
    /* [footm-5oct] (phones first, desktop since [footd-5oct]) Ilyas 5 Oct: delivery line straight under the total,
       "Free UK delivery" dropped from the note (the delivery line already says it), "No extra charges at
       checkout" on its own line. After the cutoff the line would otherwise lose the word "free", so the
       line says "Free UK delivery <date>". */
    /* [footd-5oct] Owner 5 Oct: "apply the same changes for desktop too". The phone layout below is now used
       at ALL widths (was phones only); the old desktop markup was removed. Desktop sizing lives in the
       min-width 990px block in samedi-light.css. Pre-change file: analysis-5oct/cart/samedi.LIVE-before.js */
    /* [twopiece-1nov] 2+ eligible pieces: "Two-piece saving -£X" above TOTAL, muted line under it (snippets/samedi-twopiece.liquid). Undo: delete tpf and its two uses. */
    var tpf = { above: '', below: '' };
    if (window.samediTwoPiece && window.samediTwoPiece.foot) { try { tpf = window.samediTwoPiece.foot(cart); } catch (e) {} }
    foot.innerHTML = tpf.above +
      '<div class="scd-sum"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' + tpf.below +
      /* [typem-5oct] one-line copy (Codex type pass): "Order by 3pm · Free UK next-day delivery",
         after the cutoff "Order now · Free UK delivery Tue 6 Oct". "by" matches the Google ad headline. */
      '<p class="scd-arrival scd-arrival--m">' + (function () {
        if (window.samediShipsNextDay()) return '<b>Order by ' + scdCutoffLabel() + '</b> · Free UK next-day delivery';
        try { return '<b>Order now</b> · Free UK delivery ' + scdFmtDate(scdArrivalDate()); }
        catch (e) { return '<b>Order now</b> · Free UK delivery'; }
      })() + '</p>' +
      '<p class="scd-note scd-note--m">No extra charges at checkout.</p>' +
      '<p class="scd-fine">International delivery and import charges may apply.</p>' +
      '<a class="btn btn-primary btn-block" href="/checkout">Checkout · ' + money(cart.total_price) + '</a>';

    /* Kept as the escape hatch for the minority who want the full page. The two reviews
       disagreed about this link: one wanted it gone because it leads to a page offering
       "Add a discount code" on a brand that is deliberately not discount led, the other
       wanted it kept as a way out. Keeping it, because the header bag icon now opens this
       drawer, so removing it would leave /cart reachable only by typing the URL.
       ⚠️ The discount field on /cart is a real point and is Ilyas's call. */
    /* [bagtrust-11oct] Ilyas 11 Oct: one reassurance line under the wallets, as Gymshark, Cernucci and Hatton Labs
       do under their checkout button (Baymard: 19% abandon over card trust, 13% over returns). Facts as on the PDP:
       free 30-day returns, 12 month guarantee. Text only: the card-icon row stays hidden on phones (cramped). */
    tail.innerHTML =
      '<p class="scd-trust"><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="5" y="11" width="14" height="10" rx="1.5"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>Secure checkout · Free 30-day returns · 12 month guarantee</p>' +
      '<a class="scd-view" href="' + (routes.cart_url || '/cart') + '">View full bag</a>';
  }

  /* ==================================================================
     ⭐⭐ [qtyfix-26sep] THE BAG USED TO TELL PEOPLE IT WAS EMPTY WHEN IT WAS NOT.
     Found by a full site test, 26 Sep, and it was the worst fault on the site.

     WHAT HAPPENED: tap + on a line whose stock will not stretch, Shopify answers
     **HTTP 422** with `{status, message, description}` and NO `items` array. This function
     never checked `r.ok`, so that error object went straight into scdRender, which reads
     `cart.items.length` as 0 and draws "Your bag is empty" with a Shop the Classics button.
     **The Checkout button disappeared.** The item was still in the cart and the header badge
     still said 1, so the shopper believed he had lost his £140 bracelet and had no way to pay.
     It stuck until a reload. It fired on the FIRST tap of + on Vanguard Block, Ridge Line,
     Meridian, Onyx Cuban 5mm and three Atlas Figaro variants, every product with 1 to 3 units.

     THE FIX: check `r.ok`. On a refusal, re-read the REAL cart from Shopify and draw that, so
     the bag can never show a state the server did not send, then tell the shopper why in
     Shopify's own words ("All 2 Onyx Cuban are in your cart").
     ⚠️ The message is Shopify's `description` (falling back to `message`), not wording of our
     own, so it always states the true remaining stock and needs no maintenance.
     ⚠️ scdRender wipes `body`, so the note is added AFTER the re-render, not before.
     ⛔ Never render a cart object straight from a fetch without checking the response first.
     ================================================================== */
  function scdNote(text) {
    if (!scd || !text) return;
    var body = scd.querySelector('[data-scd-body]') || scd.querySelector('.scd-body');
    if (!body) return;
    var old = body.querySelector('.scd-warn');
    if (old) old.remove();
    var p = document.createElement('p');
    p.className = 'scd-warn';
    p.setAttribute('role', 'status');
    p.textContent = text;
    body.insertBefore(p, body.firstChild);
    clearTimeout(scdNote._t);
    scdNote._t = setTimeout(function () { if (p && p.parentNode) p.remove(); }, 6000);
  }

  function scdChange(line, quantity, srcBtn) {
    if (srcBtn) srcBtn.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (res.ok && res.data && res.data.items) {
          scdRender(res.data);
          refreshCartCount();
          return;
        }
        /* Shopify refused. Draw the cart it actually holds, then say why. */
        var why = (res.data && (res.data.description || res.data.message)) || '';
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r2) { return r2.json(); })
          .then(function (cart) {
            scdRender(cart);
            refreshCartCount();
            scdNote(why || 'We could not change that quantity.');
          });
      })
      .catch(function () {
        if (srcBtn) srcBtn.disabled = false;
        scdNote('Something went wrong. Your bag has not changed.');
      });
  }

  function scdKey(e) {
    if (e.key === 'Escape' || e.keyCode === 27) { scdClose(); return; }
    if (e.key !== 'Tab' || !scd || scd.hidden) return;
    var f = scd.querySelectorAll('a[href], button:not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- express wallets ----------
     Apple Pay, PayPal and Google Pay, pulled in over the Section Rendering API from
     sections/samedi-xpay.liquid. Shopify documents this as the supported way to get
     accelerated checkout buttons into a cart drawer.

     Fetched ONCE per pageview, never per render: the element tracks the cart itself, so
     re-fetching would re-initialise it for nothing. Any failure is silent by design, the
     plain Checkout button above is untouched and is always the real path. */
  var scdXpayState = 'idle';

  function scdXpayLoad() {
    if (scdXpayState !== 'idle') return;
    var mount = scd && scd.querySelector('[data-scd-xpay]');
    if (!mount) return;
    scdXpayState = 'loading';
    /* reserve the height while it loads so the Checkout button does not jump under a
       thumb that is already moving toward it. Released either way when we settle. */
    mount.classList.add('is-loading');
    /* ⚠️ NO `Accept: application/json` HEADER. On a product URL that header makes Shopify
       answer with the PRODUCT as JSON and ignore `?sections=` entirely, so the fetch
       returns 200 with a body that has no section in it. Cost an hour to spot, because the
       request looks perfectly healthy. The Section Rendering API sets a JSON content type
       by itself.
       Fetching from the root rather than the current path for the same reason: the root has
       no product to collide with. The wallet markup is cart scoped, not page scoped, so the
       path it is rendered from does not matter. */
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=samedi-xpay')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['samedi-xpay'];
        if (!html) throw new Error('no section html');
        mount.innerHTML = html;
        scdXpayState = 'done';
        mount.classList.remove('is-loading');
        /* Inserting the markup upgrades the custom element on its own once it is defined.
           Only kick the initialiser when the element has not been registered yet. */
        if (!window.customElements || !customElements.get('shopify-accelerated-checkout-cart')) {
          if (window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init) {
            try { window.Shopify.PaymentButton.init(); } catch (err) {}
          }
        }
      })
      .catch(function () {
        scdXpayState = 'failed';
        mount.innerHTML = '';
        mount.classList.remove('is-loading');
      });
  }

  function scdOpen(source) {
    if (!scdBuild()) return false;
    scdFocusReturn = document.activeElement;
    scd.hidden = false;
    /* one frame with the panel still translated off-screen, so the slide actually animates */
    requestAnimationFrame(function () { scd.classList.add('is-open'); });
    document.documentElement.classList.add('scd-open');
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        scdRender(cart);
        if (cart.item_count > 0) scdXpayLoad();
        /* The bag opening is now its own funnel step, between add to cart and checkout.
           Without it there is no way to tell "nobody opens the bag" from "people open it
           and leave", which is exactly the question that mattered before the drawer existed. */
        ce('cart_drawer_opened', { drawer_source: source || 'unknown' });
        sa('cart_drawer_opened', { source: source || 'unknown', item_count: cart.item_count });
        var x = scd.querySelector('.scd-x');
        if (x) x.focus();
      })
      .catch(function () {});
    document.addEventListener('keydown', scdKey);
    return true;
  }

  /* [twopiece-1nov] lets snippets/samedi-twopiece.liquid redraw the open bag after its own /cart/add.js. Undo: delete this block. */
  window.samediScd = {
    refresh: function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.items) { scdRender(cart); refreshCartCount(); } return cart; });
    },
    track: function (name, data) { ce(name, data); sa(name, data); },
    /* the product page "Add both" button hands over exactly as Add to bag does: add_to_cart event, badge, open the bag */
    added: function (vid) {
      ce('add_to_cart', vid ? { last_atc_variant: String(vid) } : null);
      refreshCartCount();
      if (!scdOpen('add_to_cart')) window.location.href = routes.cart_url || '/cart';
    }
  };

  function scdClose() {
    if (!scd) return;
    scd.classList.remove('is-open');
    document.documentElement.classList.remove('scd-open');
    document.removeEventListener('keydown', scdKey);
    var el = scd;
    setTimeout(function () { if (!el.classList.contains('is-open')) el.hidden = true; }, 340);
    if (scdFocusReturn && scdFocusReturn.focus) { try { scdFocusReturn.focus(); } catch (err) {} }
  }

  /* Tapping the header bag opens the drawer instead of leaving the page. The link
     still points at /cart, so if this JS ever fails to load the bag is still reachable. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest('a[data-cart-link]')) return;
    if (/^\/cart/.test(location.pathname)) return;          /* already on the full bag */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;  /* let new-tab work */
    if (scdOpen('bag_icon')) e.preventDefault();
  });

  /* ---------- add to cart: AJAX post, then open the bag drawer ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('#atc-form, .bcard-quick-form, .bcard-add-form')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    /* Capture the pristine label ONCE per button, not per submit. Capturing it per
       submit meant a second tap inside the 1700ms restore window captured the
       transient "Added ✓" and then restored to THAT permanently, so the customer
       lost the "Add to cart · £200" call to action and the price for the rest of the
       pageview. Impatient double-tapping is common on mobile. Also affects the
       quick-add buttons on collection cards, not just the PDP. */
    if (btn && btn.dataset.pristineLabel === undefined) btn.dataset.pristineLabel = btn.innerHTML;
    var original = btn ? btn.dataset.pristineLabel : '';
    /* and cancel any restore still pending, so rapid taps cannot stack timers */
    if (btn && btn._restoreT) { clearTimeout(btn._restoreT); btn._restoreT = null; }
    if (btn) btn.disabled = true;
    fetch(cartAddUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        /* ---- add failed: stay put, say why ---- */
        if (!res.ok) {
          if (btn) {
            btn.disabled = false;
            btn.innerHTML = (res.j && res.j.description) || 'Unavailable';
            btn._restoreT = setTimeout(function () { btn.innerHTML = original; }, 1700);
          }
          return;
        }

        /* ---- add succeeded: HAND THE SHOPPER TO THE BAG ----
           12Sep2026. Until today a successful add showed "Added ✓" for 1700ms plus a
           16px header badge, and that was the whole handoff: no drawer, no navigation,
           no checkout call to action. Measured result across three sources: 14 adds to
           cart produced 2 checkouts over 7-12 Sep and ZERO since 9 Sep, Shopify held 2
           abandoned checkouts since 25 Aug, and Clarity showed 1.33 pages per session.
           Nobody was reaching /cart.

           Why navigate rather than build a drawer: traffic is 98.4% mobile, the
           catalogue is 5 SKUs and pages per session is 1.33, so there is no browsing
           momentum for a drawer to protect. The only device-split A/B data available
           has drawers LOSING on mobile, worst on small catalogues (-8.4% conversion,
           -10% revenue per session), while winning on desktop, which Samedi barely
           has. /cart already carries the wallet buttons, a "Checkout · total" button,
           the payment icons and a continue-shopping link, so it is the stronger
           surface for a considered £125-200 single-item purchase.

           Navigating also restores what the 03Sep AJAX change removed: a real
           navigation, which is what Clarity's native e-commerce inference reads. */
        var pid = form.querySelector('[name=id]:checked') || form.querySelector('[name=id]');
        ce('add_to_cart', pid ? { last_atc_variant: pid.value } : null);
        refreshCartCount();

        if (btn) {
          /* leave the button disabled: we are navigating, and a second tap in the
             gap would add a second bracelet the shopper did not ask for */
          if (btn.matches('.card-quick, .bcard-quick')) {
            btn.classList.add('added');
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
          } else {
            btn.innerHTML = 'Added ✓';
          }
        }

        /* Open the bag beside the page. If the drawer cannot be built for any reason,
           fall back to navigating, so a shopper is never left with no next step. */
        if (!scdOpen('add_to_cart')) {
          window.location.href = routes.cart_url || '/cart';
          return;
        }

        /* We are staying on the page, so give the button back. 1700ms matches the
           pristine-label handling above. */
        setTimeout(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('added'); btn.innerHTML = original; }
        }, 1700);
      })
      .catch(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  });

  /* ---------- PDP variant price ---------- */
  /* ---------- product page arrival date ----------
     Same function the bag uses, so the product page and the bag can never disagree about
     delivery. Before this they were 40px apart in the funnel saying different things: the
     page said "dispatched today" as a hardcoded string with no weekday logic, on a Saturday
     when nothing ships. */
  function scdPaintArrivals() {
    document.querySelectorAll('[data-arrival]').forEach(function (el) {
      /* [nextday-25sep] innerHTML, not textContent: the line now carries <b>Order now</b>.
         The string is built in this file from fixed words, never from anything a shopper types. */
      el.innerHTML = scdArrivalLine();
    });
    document.querySelectorAll('[data-arrival-urgent]').forEach(function (el) { el.innerHTML = scdUrgencyLine(); });
  }
  scdPaintArrivals();
  /* [b8-29sep] once the official bank holiday list arrives, repaint in case it moves a date */
  scdFetchHolidays(scdPaintArrivals);
  /* [datefix-30sep] THE DATE WENT STALE. Ilyas's iPhone at 10:55 on Wed 30 Sep showed "delivery
     Wed 30 Sep", which is the line for Tue 29 Sep before 2pm: Safari restored a tab (back/forward
     cache or a suspended tab) whose line had been worked out the day before and never again. The
     line is now recomputed whenever the page is shown or brought back to the front, and once a
     minute while it is open, so it also rolls over at the 2pm cutoff without a reload. */
  window.addEventListener('pageshow', scdPaintArrivals);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scdPaintArrivals(); });
  setInterval(function () { if (!document.hidden) scdPaintArrivals(); }, 60000);

  var variants = window.samediVariants;
  if (variants) {
    var priceEl = document.querySelector('[data-price]');
    var atcPriceEl = document.querySelector('[data-atc-price]');
    /* ⚠️ The sticky mobile bar. It rendered cv.price ONCE from Liquid and nothing ever
       updated it, so on Atlas Figaro (£125 / £170) and Onyx Cuban (£165) choosing a second
       size left the primary mobile button quoting one price while the form submitted a
       different variant. Displayed price versus charged price, on the button 98.4% of
       traffic uses. */
    var mPriceEl = document.querySelector('.m-price');
    /* [21sep-stock] Same row Liquid renders server-side for the default variant (see
       samedi-product.liquid, the comment above `.rating-row`'s closing tag), rebuilt here so
       switching width without a reload keeps telling the truth about THIS variant's stock, not
       the one the page loaded with. Threshold (3 or fewer) and wording ("Only X left") match. When
       healthy, the element is removed outright, not hidden, so it costs no height either way. */
    var FLAME_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 2s5 5 5 9a5 5 0 0 1-10 0c0-1.5 1-3 1-3s1 1.5 2 1.5S12 5 12 2z"/></svg>';
    /* ==================================================================
       [stockpill-21sep] THE LOW-STOCK PILL: reveal, dismiss, remember, and keep in step with the
       variant switcher. 20Sep2026, Ilyas wanted the warning out of the rating row and floating on
       the page as a pill with an X.

       ⛔ NOTHING HERE TOUCHES LAYOUT. The pill is position:fixed, so showing, hiding and
       dismissing it cannot move the buy column by a pixel. That is why the low-stock products now
       measure identical to live.

       ⚠️ sessionStorage throws outright in a private window and when site data is blocked, so
       every read and every write is wrapped. A throw must mean "not dismissed" and keep the pill
       working, never break the page.
       ⚠️ Dismissal is remembered for the SESSION and is deliberately not per product: being told
       the same thing on the next page after saying no is the behaviour people find hostile.
       ================================================================== */
    var PILL = (function () {
      var pill = document.querySelector('[data-stockpill]');
      if (!pill) return { sync: function () {} };
      var KEY = 'samedi_stockpill_dismissed';
      var txEl = pill.querySelector('[data-stockpill-tx]');
      var closeEl = pill.querySelector('[data-stockpill-close]');
      var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var DELAY = 2500, OUT = 420;
      var revealTimer = null, hideTimer = null, live = false;
      /* [stocktext-10oct] The low-stock notice is now plain text under the size chips, rendered
         visible by Liquid. It has no close button, so: no 2.5s reveal (that would shift the buy box),
         no session dismissal and no Escape. Variant switching (sync) is unchanged.
         TO UNDO: delete these two lines and the `STATIC` checks below. */
      var STATIC = pill.hasAttribute('data-stockpill-static');
      if (STATIC) { DELAY = 0; OUT = 0; }

      function dismissed() { if (STATIC) return false; try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
      function remember() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }

      function show() {
        if (dismissed() || live) return;
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        live = true;
        pill.hidden = false;
        if (mq && mq.matches) { pill.classList.add('is-in'); return; }
        /* two frames: the first commits `hidden` being gone and the starting opacity, the second
           starts the transition. One frame is not reliably enough and the pill snaps in. */
        requestAnimationFrame(function () { requestAnimationFrame(function () { pill.classList.add('is-in'); }); });
      }

      /* `forget` false = the variant no longer qualifies, so it may come back on a switch back.
         `forget` true = the visitor dismissed it, so it must not. */
      function hide(forget) {
        if (forget) remember();
        if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
        if (!live) { pill.hidden = true; return; }
        live = false;
        pill.classList.remove('is-in');
        if (hideTimer) clearTimeout(hideTimer);
        hideTimer = setTimeout(function () { pill.hidden = true; hideTimer = null; }, OUT);
      }

      if (closeEl) closeEl.addEventListener('click', function () { hide(true); });
      document.addEventListener('keydown', function (e) {
        if (!STATIC && (e.key === 'Escape' || e.key === 'Esc') && live) {
          /* ⚠️ the size guide and the cart drawer both close on Escape too. They are modal and own
             the key while open, so the pill only takes it when neither is up. */
          if (document.documentElement.classList.contains('scd-open')) return;
          var sg = document.querySelector('.sg-modal');
          if (sg && !sg.hasAttribute('hidden')) return;
          hide(true);
        }
      });

      if (STATIC) show(); else if (!dismissed()) revealTimer = setTimeout(show, DELAY);

      return {
        /* Called after every variant switch. A variant with a healthy count retires the pill
           WITHOUT remembering, so switching back can bring it up again; a dismissed pill stays
           dismissed either way because show() checks. */
        sync: function (v) {
          var low = (v.available !== false && typeof v.qty === 'number' && v.qty > 0 && v.qty <= 3);
          if (!low) { hide(false); return; }
          /* [len-24sep] Name the WIDTH, never the combined variant title. Once a Length option
             exists `v.title` is "5mm / 20cm", so the old `/mm$/` test stopped matching and the
             pill silently dropped the width on the first switch, while Liquid had printed the
             whole title on load. `v.w` is the width when the product has a Length option; with
             no Length option it is empty and `v.title` IS the width, which is the old behaviour. */
          var pillOpt = v.w || v.title || '';
          /* [sm-28sep] one width per listing: name the SIZE ("in M"), the same rule as the Liquid. */
          var pillIn = pillOpt.indexOf('mm') > -1 ? pillOpt : '';
          var pillSz = v.l === '18cm' ? 'S' : (v.l === '20cm' ? 'M' : '');
          if (pillIn && pillSz && !document.querySelector('#atc-form .opt-select[data-opt=width]')) pillIn = pillSz;
          if (txEl) txEl.textContent = 'Only ' + v.qty + ' left' + (pillIn ? ' in ' + pillIn : '');
          if (dismissed()) return;
          if (live) return;
          if (revealTimer) { clearTimeout(revealTimer); revealTimer = null; }
          show();
        }
      };
    })();

    /* The out-of-stock line is the only stock message still in the rating row. It is static, it
       is never a pill, and it is rebuilt here on a variant switch exactly as before. */
    function updateStockLine(v) {
      var ratingRow = document.querySelector('.pdp .rating-row');
      if (!ratingRow) return;
      var existingOut = ratingRow.querySelector('[data-stock-line]');
      if (existingOut) existingOut.remove();
      if (v.available === false) {
        ratingRow.insertAdjacentHTML('beforeend', '<div class="stock-line stock-out" data-stock-line>Currently unavailable</div>');
      }
      PILL.sync(v);
    }
    /* Everything a variant switch has to repaint, in one place, so the single-option picker
       below and the two-option picker after it cannot drift apart. */
    function paintVariant(v) {
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price;
      if (atcPriceEl) atcPriceEl.textContent = v.priceShort;
      /* the sticky mobile bar, previously never updated. priceShort matches the format
         Liquid rendered it with (money_without_trailing_zeros). */
      if (mPriceEl) mPriceEl.textContent = v.priceShort;
      var wEl = document.querySelector('[data-spec-weight]');
      if (wEl && v.weight) wEl.textContent = v.weight;
      updateStockLine(v);
    }
    /* [dd-25sep] The old single-option product rendered one radio per variant named `id` inside
       `.sizes`, and this listener repainted the price from it. Those radios are gone: every product
       now goes through the dropdown resolver below, which calls the same paintVariant. Kept as a
       no-op (it matches nothing) so that reverting the markup brings the behaviour back with it. */
    document.querySelectorAll('.pdp .sizes input[name=id]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        paintVariant(variants[radio.value]);
      });
    });

    /* ==================================================================
       [len-24sep] THE OPTION PICKER: the width and length choices -> ONE variant id.
       24Sep2026 for Atlas Figaro and Anvil Weave gaining an 18cm.
       [dd-25sep] 25Sep2026 the chips became native <select>s and EVERY product with more
       than one variant now resolves through here, not just the two-length ones.

       ⛔ THE RULE THIS CODE EXISTS TO KEEP. The two selects are named `samedi-opt-width`
       and `samedi-opt-length`, never `id`. The ONLY element in #atc-form named `id` is the
       hidden input this function writes the resolved variant id into. That is what
       Shopify's /cart/add posts and what the Fly add-to-cart logger reads
       (`[name=id]:checked || [name=id]`, so a hidden input is found by the fallback).
       ⛔ A `<select name="id">` would be found by that same selector and would hand back an
       option value such as "5mm" instead of a variant id, so every add to cart would be
       logged against the wrong thing. Never rename these selects.

       Runs only when the markup is present, so it is inert on a one-variant product.
       ================================================================== */
    (function () {
      var form = document.getElementById('atc-form');
      if (!form) return;
      var hidden = form.querySelector('input[type=hidden][name=id]');
      var wGroup = form.querySelector('.opt-select[data-opt=width]');
      var lGroup = form.querySelector('.opt-select[data-opt=length]');
      /* [dd-25sep] was `!hidden || !lGroup`, which skipped every product without a Length
         option. Onyx Cuban and the six rings now have a width/size select and no length
         select, so either group is enough to run. */
      if (!hidden || (!wGroup && !lGroup)) return;

      var submitBtn = form.querySelector('[type=submit]');
      var lenCell = document.querySelector('[data-spec-length]');

      /* "5mm||20cm" -> variant id. Built from the same map the price and stock come from,
         so there is one source of truth for what exists. */
      var byPair = {};
      Object.keys(variants).forEach(function (id) {
        var v = variants[id];
        byPair[(v.w || '') + '||' + (v.l || '')] = id;
      });

      /* [dd-25sep] the group IS the <select>, so its own value is the choice. */
      function picked(group) {
        return group ? group.value : '';
      }
      /* ⚠️ CAUGHT IN TESTING, 24 Sep. Anvil Weave has ONE width, so no width control is rendered
         and `picked(wGroup)` is the empty string. Keying the lookup on ""||20cm found nothing, the
         hidden id went blank and Add to cart read "Unavailable" on a product that is in stock.
         [dd-25sep] That fix was written for the missing WIDTH control only. It is now written both
         ways round, because a product can be missing either control: whichever option has a single
         value is not rendered, so the control that IS rendered has to identify the variant on its
         own. Onyx Cuban and the rings have no length control today; a product with two widths and
         one length would have no length control tomorrow and used to fall into the same hole.
         A pair that genuinely does not exist still returns '', and the caller disables the button. */
      function idFor(w, l) {
        var exact = byPair[(w || '') + '||' + (l || '')];
        if (exact) return exact;
        var found = '';
        Object.keys(variants).some(function (id) {
          var v = variants[id];
          if (wGroup && (v.w || '') !== w) return false;
          if (lGroup && (v.l || '') !== l) return false;
          found = id;
          return true;
        });
        return found;
      }

      /* [dd-25sep] Repaint one <select>: every option whose pairing with the OTHER select's
         current choice is unavailable, or does not exist as a variant at all, reads
         "(Sold out)" and is disabled, so it cannot be chosen by mouse, touch or keyboard.
         Liquid renders the identical state for the variant the page loads with (see `pair_map`
         in sections/samedi-product.liquid); this only keeps it true as the other select moves,
         so a visitor with JavaScript off still cannot pick something that is not there.

         ⚠️ THE SELECTED OPTION IS NEVER DISABLED. Some engines re-pick the first enabled option
         when the selected one is disabled, which would silently change the size a man is looking
         at. It keeps its "(Sold out)" label instead, and Add to Cart says "Sold out" below, which
         is the stronger signal and was already the behaviour.
         ⚠️ The label text is rebuilt from `data-base`, captured once on the first pass, so the
         suffix can never be appended twice. */
      /* ⭐ [oos-3oct] Ilyas asked for "(Out of stock)" rather than "(Sold out)" on the size options,
         and that wording was changed in samedi-product.liquid on 2 Oct WITHOUT changing this constant.
         The base-label cache below stripped a trailing " (Sold out)" only, so it failed to recognise
         the new Liquid label, cached "S (Out of stock)" as the base and painted its own suffix on the
         end: "S (Out of stock) (Sold out)" on the Onyx Cuban 5mm.
         This painter owns the runtime wording, so the constant is the single source of truth and the
         strippers below accept EITHER wording, so a cached page cannot double up. ⛔ The Add to Cart
         button keeps saying "Sold out" - that is a different string and Ilyas settled it.
         ⚠️ The matching pattern is written out at each of the three sites ON PURPOSE. They sit in
         THREE SEPARATE SCOPES in this file, so a single shared const throws
         "SOLD_RE is not defined" at two of them. Do not refactor it into one variable. */
      /* ⭐ [oosnotify-3oct] Ilyas, 3 Oct: "why would they pick S if it says it is out of stock?" Fair.
         "S (Out of stock)" reads as a dead end, so nobody taps it and the notify flow behind it is
         never found. His suggestion was to drop the words and just make it clickable, but that trades
         a dead end for a small deception: a man picks S expecting to buy, and only then is told it is
         gone. The label now carries the TRUTH AND THE DOOR, so it costs no height and no honesty.
         ⚠️ The strippers above match any parenthetical starting "(Out of stock" or "(Sold out", so
         this wording can be changed again without the suffix doubling up. "(N/A)" is NOT matched and
         must not be: it is on a different select that this painter never touches. */
      var SOLD = ' (Out of stock, notify me)';
      function paintGroup(group, otherValue, groupIsWidth) {
        if (!group) return;
        [].forEach.call(group.options, function (o) {
          /* [pickfix-30sep] The size gate's "Select option" placeholder (value "__pick", added by
             [sizepick-29sep] below) is not a size. It maps to no variant, so this painter was
             labelling it "Select option (Sold out)" once a size was chosen. Skip it: it keeps its
             plain text and the disabled state the gate gave it. */
          if (o.value === '__pick') return;
          if (o.dataset.base === undefined) {
            o.dataset.base = o.textContent.replace(/\s*\((?:Sold out|Out of stock)[^)]*\)\s*$/, '');
          }
          var id = groupIsWidth ? idFor(o.value, otherValue) : idFor(otherValue, o.value);
          var v = id ? variants[id] : null;
          var ok = !!v && v.available !== false;
          o.textContent = o.dataset.base + (ok ? '' : SOLD);
          o.disabled = !v;
        });
      }

      /* ⚠️ The first run is a PAINT ONLY. Liquid already rendered the right price, the right
         Length cell and the right stock row for the default variant, and calling paintVariant
         here would hand the low-stock pill its reveal immediately instead of after its 2.5s
         delay. So the first run sets the hidden id and the sold-out chips, and nothing else. */
      var first = true;

      function sync() {
        var w = picked(wGroup), l = picked(lGroup);
        var id = idFor(w, l);
        paintGroup(wGroup, l, true);
        paintGroup(lGroup, w, false);
        if (!id) {
          /* The pair does not exist as a variant at all. Nothing is posted rather than
             something wrong being posted, and the button says so. */
          hidden.value = '';
          if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Unavailable'; }
          first = false;
          return;
        }
        hidden.value = id;
        var v = variants[id];
        /* ⚠️ [dd-25sep] BUG FOUND 25 Sep, and it is OLDER than the dropdowns: it is in the 24 Sep
           code and on the live theme today. Liquid draws Add to Cart from `p.available`, which is
           PRODUCT-level and true whenever any variant is buyable, and the `first` guard below then
           skipped the button update on the first pass. So landing straight on a sold-out variant
           (/products/atlas-figaro-bracelet?variant=<the 5mm/18cm>, which is what a Google result, an
           old ad link or a shared link does) showed a live "Add to cart, £85" for something with
           zero stock. Shopify would have refused it at /cart/add with an error.
           Fixed by running the normal repaint on the first pass WHEN, AND ONLY WHEN, the variant is
           unavailable. That is safe against the reason the guard exists: the guard is there to stop
           the low-stock pill jumping its 2.5s delay, and a variant with no stock never qualifies for
           that pill anyway (PILL.sync retires it). An AVAILABLE first load still skips, exactly as
           before, so nothing else about the first paint changes. */
        var soldOnLoad = first && !!v && v.available === false;
        if (first && !soldOnLoad) { first = false; return; }
        first = false;
        paintVariant(v);
        if (lenCell && v.l) lenCell.textContent = ({'18cm':'19cm','20cm':'21.5cm'}[v.l] || v.l) + ' (Relaxed Fit)'; /* [sizes-27oct] real length with clasp */
        if (submitBtn) {
          if (v.available === false) {
            /* ⭐ [bisbtn-3oct] The notify prompt USED to be a panel above Add to Cart, which Ilyas
               rejected for pushing the real button down the page. Researched pattern across stores is
               that the notification CTA replaces Add to Cart rather than sitting beside it, which costs
               no vertical space at all. So on a sold-out size this button becomes the notify button and
               opens the modal; `data-notify` carries the variant the modal subscribes to.
               ⚠️ Falls back to the old disabled "Sold out" whenever the capture is switched off, so a
               store with no Klaviyo key never shows a button that cannot do anything. */
            /* ⚠️ [shipline-3oct] `.ship-line` says "In stock. Free next day delivery" straight from
               Liquid and never followed the variant, so a sold-out size showed "In stock" and
               "Currently unavailable" at the same time. It was already reachable by landing on a
               sold-out variant through a ?variant= link; making out-of-stock sizes selectable makes it
               reachable by just using the dropdown, so it is fixed here rather than left. */
            var shipLine = document.querySelector('.ship-line');
            if (shipLine) shipLine.hidden = true;
            var nfx = document.querySelector('[data-bisx]');
            var nfOn = nfx && nfx.getAttribute('data-on') === '1';
            var sizeLab = (v.l === '18cm') ? 'S' : ((v.l === '20cm') ? 'M' : (v.l || ''));
            if (nfOn) {
              submitBtn.disabled = false;
              submitBtn.textContent = sizeLab ? ('Notify me when ' + sizeLab + ' is back') : 'Notify me when back in stock';
              submitBtn.setAttribute('data-notify', id);
              submitBtn.setAttribute('data-notify-size', sizeLab);
            } else {
              submitBtn.disabled = true;
              submitBtn.textContent = 'Sold out';
              submitBtn.removeAttribute('data-notify');
            }
          } else {
            var shipLineOk = document.querySelector('.ship-line');
            if (shipLineOk) shipLineOk.hidden = false;
            submitBtn.removeAttribute('data-notify');
            submitBtn.disabled = false;
            submitBtn.innerHTML = 'Add to bag &middot; <span data-atc-price>' + v.priceShort + '</span>';
            atcPriceEl = form.querySelector('[data-atc-price]');
          }
        }
        /* The sticky phone bar submits THIS form (form="atc-form"), and Liquid disables it from
           `p.available` too, so it had the same fault: live on a sold-out variant. It carries no
           price of its own beyond `.m-price`, which paintVariant already updates. */
        var mBtn = document.querySelector('.mcart [type=submit]');
        if (mBtn) {
          var nfx2 = document.querySelector('[data-bisx]');
          var nfOn2 = nfx2 && nfx2.getAttribute('data-on') === '1';
          if (v.available === false && nfOn2) {
            mBtn.disabled = false;
            mBtn.textContent = 'Notify me';
            mBtn.setAttribute('data-notify', id);
          } else {
            mBtn.removeAttribute('data-notify');
            mBtn.disabled = (v.available === false);
            mBtn.textContent = (v.available === false) ? 'Sold out' : 'Add to bag';
          }
        }
      }

      [wGroup, lGroup].forEach(function (g) {
        if (g) g.addEventListener('change', sync);
      });
      sync();
    })();
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'samedi_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; } }
  function wlSet(a) { localStorage.setItem(WKEY, JSON.stringify(a)); }
  function wlHas(h) { return wlGet().indexOf(h) > -1; }
  function wlToggle(h) { var a = wlGet(), i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); wlSet(a); return a.indexOf(h) > -1; }

  function markHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (b) {
      b.classList.toggle('is-saved', wlHas(b.getAttribute('data-handle')));
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wishlist-toggle]');
    if (!b) return;
    e.preventDefault();
    var nowSaved = wlToggle(b.getAttribute('data-handle'));
    b.classList.toggle('is-saved', nowSaved);
    // On the wishlist page, un-saving removes the card
    // 23 Sep 2026 (round 52): the wishlist page now prints the shop's own card (.lt), so that
    // is the element to remove. .bcard and .card are kept in case an old card is still rendered.
    var wlGridEl = document.querySelector('[data-wishlist-grid]');
    if (!nowSaved && wlGridEl) {
      var card = b.closest('.lt, .bcard, .card');
      if (card && wlGridEl.contains(card)) card.remove();
      var emptyEl = document.querySelector('[data-wishlist-empty]');
      if (!wlGridEl.querySelector('.lt, .bcard, .card')) {
        wlGridEl.style.display = 'none';
        if (emptyEl) emptyEl.style.display = '';
      }
    }
  });
  markHearts();

  /* ---------- Wishlist page: keep the saved cards ----------
     23 Sep 2026 (round 52), Ilyas: "Can you make the products that appear be the same design as
     our collection product cards." This block used to BUILD a card in JavaScript, which is why
     the wishlist still showed the old dark tile with a "925 - Hallmarked" chip and a "View
     product" link. sections/samedi-wishlist.liquid now prints the shop's own card
     (snippets/samedi-lcard.liquid, with add to cart) for every live product, hidden. All this
     does is throw away the ones that are not saved, put the rest in the order they were saved,
     and show the grid. No fetch, no markup built here, so the card can only ever be the one the
     collection page uses. */
  var grid = document.querySelector('[data-wishlist-grid]');
  if (grid) {
    var handles = wlGet();
    var empty = document.querySelector('[data-wishlist-empty]');
    var cards = [].slice.call(grid.querySelectorAll('.lt'));
    var byHandle = {};
    cards.forEach(function (c) {
      var b = c.querySelector('[data-wishlist-toggle][data-handle]');
      var h = b && b.getAttribute('data-handle');
      if (h && !byHandle[h]) byHandle[h] = c;
    });
    var kept = [];
    handles.forEach(function (h) {
      var c = byHandle[h];
      if (c && kept.indexOf(c) < 0) kept.push(c);
    });
    cards.forEach(function (c) { if (kept.indexOf(c) < 0 && c.parentNode) c.parentNode.removeChild(c); });
    kept.forEach(function (c) { grid.appendChild(c); });
    if (kept.length) {
      grid.style.display = '';
      if (empty) empty.style.display = 'none';
    } else {
      grid.style.display = 'none';
      if (empty) empty.style.display = '';
    }
  }

  /* ---------- Promo code -> Shopify discount session (carries to checkout) ---------- */
  var promo = document.querySelector('[data-promo-form]');
  if (promo) {
    var applyPromo = function () {
      var input = promo.querySelector('input');
      var code = input && input.value ? input.value.trim() : '';
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    };
    var pbtn = promo.querySelector('[data-promo-apply]');
    if (pbtn) pbtn.addEventListener('click', applyPromo);
    var pinput = promo.querySelector('input');
    if (pinput) pinput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyPromo(); } });
  }
  // Remove an applied discount code (clears the cart's discount session, then reloads)
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-promo-remove]');
    if (!rm) return;
    e.preventDefault();
    rm.disabled = true;
    fetch('/discount?discount=', { method: 'GET' })
      .catch(function () {})
      .then(function () {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).catch(function () {});
      })
      .then(function () { window.location.href = '/cart'; });
  });

  /* ---------- Read-a-review modal (PDP review cards) ---------- */
  var rvrModal = document.getElementById('rvrModal');
  if (rvrModal) {
    var rvrStars = rvrModal.querySelector('[data-rvr-stars]');
    var rvrTitle = rvrModal.querySelector('[data-rvr-title]');
    var rvrQuote = rvrModal.querySelector('[data-rvr-quote]');
    var rvrName = rvrModal.querySelector('[data-rvr-name]');
    var rvrVerified = rvrModal.querySelector('[data-rvr-verified]');

    // Only offer "Read more" on cards whose text is actually cut off.
    var markClamped = function () {
      document.querySelectorAll('.rev .rev-body').forEach(function (body) {
        var card = body.closest('.rev');
        if (!card) return;
        card.classList.toggle('is-clamped', body.scrollHeight - body.clientHeight > 2);
      });
    };
    markClamped();
    window.addEventListener('resize', markClamped);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(markClamped);

    var closeRvr = function () {
      rvrModal.classList.remove('open');
      document.body.style.overflow = '';
    };

    document.addEventListener('click', function (e) {
      var card = e.target.closest('[data-rev-open]');
      if (card) {
        e.preventDefault();
        var n = parseInt(card.getAttribute('data-stars'), 10) || 5;
        if (rvrStars) rvrStars.textContent = '★★★★★'.slice(0, n) + '☆☆☆☆☆'.slice(0, 5 - n);
        var t = card.getAttribute('data-title') || '';
        if (rvrTitle) { rvrTitle.textContent = t; rvrTitle.hidden = !t; }
        if (rvrQuote) rvrQuote.textContent = card.getAttribute('data-quote') || '';
        if (rvrName) rvrName.textContent = card.getAttribute('data-name') || '';
        if (rvrVerified) rvrVerified.hidden = !card.getAttribute('data-verified');
        rvrModal.classList.add('open');
        document.body.style.overflow = 'hidden';
        return;
      }
      if (e.target.closest('[data-rev-close]')) closeRvr();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && rvrModal.classList.contains('open')) closeRvr();
    });
  }

  /* ---------- Review modal ---------- */
  var rvModal = document.getElementById('rvModal');
  if (rvModal) {
    var rvProductInput = document.getElementById('rvProduct');
    var rvProductLabel = rvModal.querySelector('[data-review-product]');
    var rvForm = document.getElementById('rvForm');
    var rvFormWrap = rvModal.querySelector('.rv-form-wrap');
    var rvThanks = rvModal.querySelector('.rv-thanks');
    var openReview = function (name, handle, source) {
      /* [rvproduct-26sep] `source` is for openers with no product in scope, such as the button
         on /pages/reviews, which used to post an EMPTY product field. It is appended to the
         POSTED value only and never to the heading, which keeps its "this piece" fallback. */
      if (rvProductInput) rvProductInput.value = (name || '') + (handle ? ' (' + handle + ')' : '') + (source ? (name ? ' ' : '') + '[from: ' + source + ']' : '');
      if (rvProductLabel) rvProductLabel.textContent = name || 'this piece';
      if (rvFormWrap) rvFormWrap.style.display = '';
      if (rvThanks) rvThanks.style.display = 'none';
      rvModal.classList.add('open');
      document.body.style.overflow = 'hidden';
    };
    var closeReview = function () { rvModal.classList.remove('open'); document.body.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-review-open]');
      if (opener) { e.preventDefault(); openReview(opener.getAttribute('data-product'), opener.getAttribute('data-handle'), opener.getAttribute('data-review-source')); return; }
      if (e.target.closest('[data-review-close]')) closeReview();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeReview(); });
    var rvStars = document.getElementById('rvStars');
    var rvRating = document.getElementById('rvRating');
    if (rvStars && rvRating) {
      rvStars.querySelectorAll('.rv-star').forEach(function (star) {
        star.addEventListener('click', function () {
          var v = +star.getAttribute('data-v');
          rvRating.value = v;
          rvStars.querySelectorAll('.rv-star').forEach(function (s) { s.classList.toggle('on', +s.getAttribute('data-v') <= v); });
        });
      });
    }
    if (rvForm) {
      rvForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var sbtn = rvForm.querySelector('[type=submit]');
        if (sbtn) sbtn.disabled = true;
        /* ⭐ [rvfail-26sep] IT USED TO SAY THANK YOU EVEN WHEN THE REVIEW NEVER SENT.
           `.catch(function(){})` swallowed the failure and the `.then` ran regardless, and
           `response.ok` was never read. Proved in testing: the request was blocked and the
           form still said "Thanks for your review. We read every one." So a shopper whose
           review failed was told it had worked, and the review was lost with no way to know.
           Now the thank you is shown ONLY on a successful response; anything else puts the
           form back with the button live so it can be sent again. */
        var rvErr = rvForm.querySelector('[data-rv-error]');
        if (rvErr) rvErr.hidden = true;
        fetch(rvForm.getAttribute('action') || '/contact', { method: 'POST', body: new FormData(rvForm) })
          .then(function (r) {
            if (!r.ok) throw new Error('review post failed: ' + r.status);
            if (rvFormWrap) rvFormWrap.style.display = 'none';
            if (rvThanks) rvThanks.style.display = 'block';
          })
          .catch(function () {
            if (sbtn) sbtn.disabled = false;
            if (rvErr) { rvErr.hidden = false; }
            else {
              var p = document.createElement('p');
              p.className = 'rv-error';
              p.setAttribute('role', 'alert');
              p.textContent = 'Sorry, that did not send. Please try again.';
              rvForm.appendChild(p);
            }
          });
      });
    }
  }
})();

/* ==================================================================
   [chips-25sep] THE WIDTH AND LENGTH DROPDOWNS ARE DRAWN AS BUTTONS.
   Ilyas 25 Sep, with a Craftd screenshot: "Change the drop down to buttons instead like
   craftd. But obviously make it sleeker."

   ⛔⛔ THE <select> IS NOT REMOVED AND IS NOT RENAMED. It stays in the form as the single
   source of truth and is only hidden from view. Everything that resolves a variant keeps
   working untouched: `[dd-25sep]`'s picker still reads `.opt-select[data-opt=width|length]`
   and `.value`, still repaints `(Sold out)` on its <option>s, and still writes the ONE
   hidden input named `id`. Nothing here ever posts a value, and no element added here
   carries a name at all, so `#atc-form [name=id]:checked || #atc-form [name=id]` is
   unchanged and the add-to-cart logger still records the real variant id.

   ⭐ The buttons are BUILT FROM the <select>'s own options, so the words on a chip can never
   disagree with the option behind it, including the "(Sold out)" suffix the picker paints on
   as the other control moves. One `change` listener on the form redraws both groups, which
   covers a click here, a keyboard change, and the picker's own repaint of the other group.

   ⭐ IT DEGRADES. The select is hidden by `.opt-sel--chips` on the ROW, added only once a
   group has actually been built. With JavaScript off, nothing runs and the dropdown is
   still there, working, which is the state the page ships in.
   ================================================================== */
(function () {
  var form = document.getElementById('atc-form');
  if (!form) return;
  /* [speed-3nov] the buttons are now built early by snippets/samedi-chips-early.liquid; repaint them here, where they
     used to be built, so they follow the size picker's first pass exactly as before. */
  if (window.__samediChips) { window.__samediChips(); return; }
  /* [craftd-25sep] THE ONE-VALUE ROWS. They have no <select>, so they must be handled BEFORE
     the early return below, which exists for products with no dropdown at all.
     ⚠️ THIS WAS A REAL BUG, CAUGHT BY MEASURING FOUR PRODUCTS: King's Byzantine and the Voyager
     Anchor have a fixed width AND a fixed length, so `groups.length` is 0, the function returned
     immediately, and their headings read "Bracelet Width" with no value while every other
     product read "Bracelet Width: Slim - 5mm".
     The value is copied from the printed line already on the page, so there is one source of
     truth and nothing new is stated. Runs once: a fixed row cannot change. */
  [].forEach.call(form.querySelectorAll('.opt-row--fixed'), function (row) {
    var lab = row.querySelector('.opt-label'), val = row.querySelector('.opt-fixed');
    if (!lab || !val || lab.querySelector('.opt-val')) return;
    var sp = document.createElement('span');
    sp.className = 'opt-val';
    sp.textContent = ': ' + val.textContent.trim();
    lab.appendChild(sp);
  });

  var groups = [].slice.call(form.querySelectorAll('.opt-select[data-opt]'));
  if (!groups.length) return;

  var built = [];
  groups.forEach(function (sel) {
    var row = sel.closest('.opt-row');
    if (!row) return;
    var box = document.createElement('div');
    box.className = 'opt-chips';
    box.setAttribute('role', 'group');
    var lab = row.querySelector('.opt-label');
    if (lab) box.setAttribute('aria-label', lab.textContent.trim());
    /* [craftd-25sep] The heading prints the CHOSEN value after a colon, the way Craftd does:
       "Bracelet Width: Slim - 5mm". The <span> is added once and only its text is rewritten,
       so the label's own words are never rebuilt and nothing that reads them can drift.
       ⚠️ The colon lives on the span, not on the Liquid string, so a product with no value yet
       shows a bare heading rather than a heading with a dangling colon. */
    var labVal = null;
    if (lab) {
      labVal = lab.querySelector('.opt-val');
      if (!labVal) { labVal = document.createElement('span'); labVal.className = 'opt-val'; lab.appendChild(labVal); }
    }
    /* One button per option, in the select's order. */
    [].forEach.call(sel.options, function (o) {
      var b = document.createElement('button');
      b.type = 'button';                       /* never submits the form */
      b.className = 'opt-chip';
      b.setAttribute('data-val', o.value);
      b.appendChild(document.createElement('span')).className = 'opt-chip-t';
      box.appendChild(b);
    });
    row.appendChild(box);
    /* The select goes out of sight and out of the tab order; the chips carry it now. */
    row.classList.add('opt-row--chips');
    var wrap = sel.closest('.opt-sel');
    if (wrap) wrap.classList.add('opt-sel--chips');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');

    box.addEventListener('click', function (e) {
      var b = e.target.closest('.opt-chip');
      if (!b || b.disabled) return;
      if (sel.value === b.getAttribute('data-val')) return;
      sel.value = b.getAttribute('data-val');
      /* The picker listens for `change`, which a programmatic value set does not fire. */
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });

    built.push({ sel: sel, box: box, labVal: labVal });
  });
  if (!built.length) return;

  /* Mirror the select onto its chips: label, chosen state, and whether it can be picked. */
  function paint() {
    built.forEach(function (g) {
      if (g.labVal) {
        var chosen = g.sel.options[g.sel.selectedIndex];
        /* The face text, not the raw option: the chip already strips "(Sold out)" and the
           heading should read the same words the chosen chip reads. */
        g.labVal.textContent = chosen
          ? ': ' + chosen.textContent.trim().replace(/\s*\((?:Sold out|Out of stock)[^)]*\)\s*$/, '')
          : '';
      }
      var vals = {};
      [].forEach.call(g.sel.options, function (o) { vals[o.value] = o; });
      [].forEach.call(g.box.children, function (b) {
        var o = vals[b.getAttribute('data-val')];
        if (!o) return;
        /* ⚠️ THE CHIP DOES NOT PRINT "(Sold out)". On the rings that is eleven single-letter
           sizes each blown out to the width of the words, three rows deep, for information the
           strike-through already gives. The full wording stays on the chip's accessible name,
           so a screen reader hears "Size W, sold out" exactly as the option says it. */
        var full = o.textContent.trim();
        var face = full.replace(/\s*\((?:Sold out|Out of stock)[^)]*\)\s*$/, '');
        b.querySelector('.opt-chip-t').textContent = face;
        if (full !== face) b.setAttribute('aria-label', full); else b.removeAttribute('aria-label');
        var on = o.selected;
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        /* A disabled option cannot be chosen by mouse, touch or keyboard, and the chip
           must say the same thing. The SELECTED one is never disabled, the same rule the
           picker keeps, so a sold-out size a man is looking at still reads and stays put. */
        b.disabled = o.disabled;
        b.classList.toggle('out', o.disabled || full !== face);
      });
    });
  }
  form.addEventListener('change', paint);
  paint();
  /* The picker's first pass runs on its own and repaints the options; catch that too. */
  setTimeout(paint, 0);
})();

/* ==================================================================
   [sizepick-29sep] + [sizeask-29sep] SIZE MUST BE CHOSEN BEFORE ANYTHING IS BOUGHT.
   Ilyas 29 Sep, after NineTwoFive: the size dropdown opens on "Select option", not a pre-picked
   M. Revised the same night: "Removing Apple Pay and ATC for select a size isn't good for us",
   so every button LOOKS exactly as normal (Add to cart · £X, the sticky bar, PayPal / Apple
   Pay all visible and in colour). Until a size is chosen:
   - Add to cart / the sticky bar's twin: the submit is stopped in the capture phase, before the
     AJAX add handler above sees it, so no /cart/add, no add_to_cart event, no pixel;
   - the wallet: a transparent <span> catcher sits over it and a capture listener on its
     container swallows click and Enter/Space, so Shopify's wallet (which buys whatever variant
     the form holds at the moment of the tap) never starts;
   - the form's hidden variant id is LEFT on the default size. ⚠️ Emptying it (the first
     version) makes Shopify disable and fade the wallet to half opacity, which Ilyas rejected;
     so nothing is sent because every route is blocked, not because the id is empty. The
     wallet's contents are also made `inert` (no focus, no keyboard, no clicks, no visual
     change), which closes the keyboard route into PayPal's cross-origin iframe that a click
     catcher cannot see;
   - any of those taps puts a red 1px edge on the dropdown with "Please select your size" in red
     under it, scrolls to it and focuses it.
   Choosing a size fires the select's normal `change`, so the existing resolver writes the id,
   price and stock exactly as before; the red state, the catcher and this gate go for good.
   Scope: only a Length select with two or more sizes. One-size products (Onyx 7mm, Voyager),
   the rings and the collection quick-add are untouched. JavaScript off: default size stays.
   ⛔ The catcher and the message are <span>/<p>, never an empty <div> (div:empty is hidden here).
   ================================================================== */
(function () {
  var form = document.getElementById('atc-form');
  if (!form) return;
  /* [ringgate-10oct] Rings too: Ilyas 10 Oct. Rings opened on the first in-stock size (Frontier O) and the sticky bar
     added it without the man ever choosing. Their Ring size select is data-opt="width" and carries `data-gate`
     (sections/samedi-product.liquid), so it gets exactly the bracelet gate below: "Select your size" on both buttons,
     the sticky bar opens the size tray, wallet blocked until a size is picked. */
  var sel = form.querySelector('select[data-opt=length]') || form.querySelector('select[data-gate]');
  if (!sel || sel.options.length < 2) return;
  /* [presize-20oct] Ilyas 20 Oct, after the Clarity review (ad visitors stopped at "Select your size"): BRACELETS open
     with a size already chosen, one less tap and one less decision. A link that names a variant (every Google Shopping
     ad does) keeps that size, as Liquid already selected it; any other visit opens on M (20cm), the size that fits most.
     If M is sold out its option is disabled and the Liquid default stays. The gate below is skipped for bracelets.
     Rings (select[data-gate]) keep the gate. To undo: delete this block. */
  if (sel.getAttribute('data-opt') === 'length') {
    if (!/[?&]variant=/.test(location.search)) {
      var mOpt = [].filter.call(sel.options, function (o) { return (o.value === '20cm' || o.value === 'M') && !o.disabled; })[0];
      if (mOpt && sel.value !== mOpt.value) { sel.value = mOpt.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    return;
  }
  /* [/presize-20oct] */
  var hidden = form.querySelector('input[type=hidden][name=id]');
  /* [gatefix-30sep] Snapshot the page's normal state (default size id, its "Add to cart · £X"
     label, the sticky bar's label) BEFORE the placeholder goes in, so it can be put back. */
  /* ⭐ [gatefix-30sep] ROOT CAUSE FOUND IN WEBKIT. On back/forward (and a restored iPhone tab)
     Safari restores the select's saved state while the page is parsed. The saved state was our
     placeholder, which is not in the fresh HTML, so the select came back with NOTHING selected.
     The resolver's first pass then looked up an empty size, emptied the id and wrote
     "Unavailable" before this block ran, and the old snapshot below copied that broken state.
     So: put the Liquid default size back first (defaultSelected is what the HTML said, whatever
     Safari restored), let the resolver repaint from it, and only then snapshot. The label is
     built from the variant data, never copied from the button. */
  var def = [].filter.call(sel.options, function (o) { return o.defaultSelected && !o.disabled; })[0] ||
            [].filter.call(sel.options, function (o) { return !o.disabled; })[0];
  if (def && sel.value !== def.value) {
    sel.value = def.value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var mBtn0 = document.querySelector('.mcart [type=submit]');
  var vmap = window.samediVariants || {};
  var baseId = hidden ? hidden.value : '';
  var bv = vmap[baseId];
  var base = {
    id: baseId,
    atc: (bv && bv.priceShort) ? 'Add to bag &middot; <span data-atc-price>' + bv.priceShort + '</span>'
                               : (form.querySelector('[type=submit]') || {}).innerHTML,
    mcart: mBtn0 ? 'Add to bag' : null
  };
  /* ⭐ [gatelabel-3oct] Ilyas 3 Oct: while the gate is armed the select reads "Select option" but the
     button still said "Add to cart, £125", promising something it was about to refuse.
     ⚠️ Setting the button text at ARMING time does not work. `restore()` below deliberately rewrites
     the button from `base` on every change, on pageshow and on a delay after load, precisely so
     nothing else can leave the gated button in a wrong state. The label therefore has to be changed
     in `base` itself, the one thing restore() trusts.
     The price is dropped rather than kept: it is already shown directly above the button, and a button
     should describe its own action. It returns the instant a size is chosen and the tap becomes a real
     add. Price does NOT vary by size on any Samedi piece (all seven bracelets checked), so nothing is
     hidden by leaving it off until then. */
  base.atc = 'Select your size';
  if (base.mcart !== null) base.mcart = 'Select size';
  /* ⚠️ Stop the browser restoring an old choice into this select after our script has run (Safari
     does this on back/forward without the page cache), which would show a size while the gate is
     still closed. */
  sel.setAttribute('autocomplete', 'off');
  var PH = '__pick';
  var ph = document.createElement('option');
  ph.value = PH; ph.textContent = 'Select option'; ph.disabled = true;
  sel.insertBefore(ph, sel.firstChild);
  sel.selectedIndex = 0;
  form.setAttribute('data-size-pending', '');
  var wrap = sel.closest('.opt-sel') || sel;

  var msg = null;
  function ask() {
    sel.classList.add('is-err');
    sel.setAttribute('aria-invalid', 'true');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'size-err';
      msg.id = 'size-err-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Please select your size';
      wrap.parentNode.insertBefore(msg, wrap.nextSibling);
      sel.setAttribute('aria-describedby', 'size-err-msg');
    }
    try { sel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { sel.scrollIntoView(); }
    setTimeout(function () {
      try { sel.focus({ preventScroll: true }); } catch (e) { sel.focus(); }
      /* ⭐ [openpicker-3oct] Ilyas 3 Oct: "make the button lead to an action". Focusing a native
         <select> does NOT open it, so the old behaviour was a button that scrolled, went red and then
         waited for a second tap on the dropdown. showPicker() opens it properly.
         ⚠️ showPicker() throws if it is not called from a user gesture, and throws NotSupportedError
         on older Safari and Firefox, so it is wrapped: on a throw the field is still focused and
         scrolled to, which is exactly the old behaviour. Never let this break the gate.
         ⚠️ It must stay inside this setTimeout. Called immediately it races the smooth scroll and iOS
         opens the picker over a still-moving page. */
      try { if (typeof sel.showPicker === 'function') sel.showPicker(); } catch (e) {}
    }, 350);
  }
  function pending() { return form.hasAttribute('data-size-pending'); }

  /* ⭐ [gatefix-30sep] "UNAVAILABLE" ON ILYAS'S IPHONE, 30 Sep. Cause: iOS Safari fires `change` on
     a select when its picker is closed with Done even if nothing new was picked (and a restored
     page can fire it too). With the placeholder still selected the variant resolver (samedi.js,
     `sync`) looked up the size "__pick", found no variant, emptied the id, DISABLED Add to cart
     and wrote "Unavailable". A disabled button also never reaches the gate, so no red prompt.
     Fix, two layers:
     1. A capture listener on the FORM sees `change` before the select's own listeners. While the
        placeholder is selected it stops the event there, so the resolver and the chip painter
        never see "__pick".
     2. restore() puts the normal state back (default id, enabled button, "Add to cart · £X",
        sticky bar label) and runs on every change, on pageshow (back/forward cache) and after a
        short delay on load, in case anything else ever writes to them first. */
  function restore() {
    if (!pending() || sel.value !== PH) return;
    var b = form.querySelector('[type=submit]');
    if (hidden && base.id) hidden.value = base.id;
    if (b && base.atc !== undefined) { b.disabled = false; b.innerHTML = base.atc; }
    var mb = document.querySelector('.mcart [type=submit]');
    if (mb && base.mcart !== null) { mb.disabled = false; mb.innerHTML = base.mcart; }
  }
  form.addEventListener('change', function (e) {
    if (e.target === sel && sel.value === PH) {
      e.stopImmediatePropagation();
      restore();
    }
  }, true);
  window.addEventListener('pageshow', function () {
    /* A page restored with a real size already showing is treated as chosen; otherwise it goes
       back to the clean placeholder state. */
    if (pending() && sel.value !== PH) sel.dispatchEvent(new Event('change', { bubbles: true }));
    else restore();
  });
  setTimeout(function () {
    if (pending() && sel.value !== PH) sel.dispatchEvent(new Event('change', { bubbles: true }));
    else restore();
  }, 600);

  /* [mtray-30sep] Ilyas 29 Sep: the sticky bar should "let them pick their size". A tap on the
     bar's Add to cart while no size is chosen no longer scrolls back up to the dropdown: a small
     tray opens above the bar with one button per size (sold-out sizes shown, greyed, not
     tappable). Picking one sets the real dropdown (so price, id and stock resolve exactly as
     before) and then adds to cart straight away, so the shopper never leaves the bar.
     ⛔ No empty divs: the tray always carries its heading and buttons. */
  var mBar = document.querySelector('.mcart');
  var mSub = mBar ? mBar.querySelector('[type=submit]') : null;
  var lastMTap = 0;
  if (mSub) mSub.addEventListener('pointerdown', function () { lastMTap = Date.now(); }, true);
  var tray = null;
  function closeTray() { if (tray) { tray.remove(); tray = null; } }
  function openTray() {
    if (tray) return;
    tray = document.createElement('div');
    tray.className = 'mcart-tray';
    tray.setAttribute('role', 'dialog');
    tray.setAttribute('aria-label', 'Select your size');
    var h = document.createElement('p');
    h.className = 'mcart-tray-h';
    h.textContent = 'Select your size';
    tray.appendChild(h);
    var row = document.createElement('span');
    row.className = 'mcart-tray-row';
    [].forEach.call(sel.options, function (o) {
      if (o.value === PH) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mcart-chip';
      /* [ringgate-10oct] the size labels now read "(Out of stock, notify me)", not "(Sold out)"; match both,
         so a sold-out size is greyed in the tray instead of being added to the bag. */
      var soldOut = o.disabled || /\((?:sold out|out of stock)/i.test(o.textContent);
      b.textContent = o.textContent.replace(/\s*\((?:sold out|out of stock)[^)]*\)/i, '').trim();
      if (soldOut) { b.disabled = true; b.classList.add('is-out'); b.setAttribute('aria-label', b.textContent + ', sold out'); }
      b.addEventListener('click', function () {
        sel.value = o.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
        closeTray();
        setTimeout(function () {
          if (pending()) return;
          if (form.requestSubmit) form.requestSubmit(mSub || undefined); else if (mSub) mSub.click();
        }, 60);
      });
      row.appendChild(b);
    });
    tray.appendChild(row);
    mBar.appendChild(tray);
    var first = tray.querySelector('.mcart-chip:not([disabled])');
    if (first) try { first.focus({ preventScroll: true }); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    if (tray && !e.target.closest('.mcart')) closeTray();
  }, true);
  document.addEventListener('keydown', function (e) { if (tray && (e.key === 'Escape' || e.key === 'Esc')) closeTray(); });

  /* Add to cart and the sticky bar (it submits this same form). */
  document.addEventListener('submit', function (e) {
    if (e.target !== form || !pending()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fromBar = mSub && (e.submitter === mSub || (!e.submitter && Date.now() - lastMTap < 800));
    if (fromBar && mBar) openTray(); else ask();
  }, true);

  /* The wallet. Capture on the container runs before Shopify's own listeners inside it. */
  var xp = form.querySelector('.pdp-express');
  var catcher = null;
  if (xp) {
    catcher = document.createElement('span');
    catcher.className = 'xp-catch';
    catcher.setAttribute('aria-hidden', 'true');
    xp.appendChild(catcher);
    [].forEach.call(xp.children, function (c) { if (c !== catcher) c.inert = true; });
    var block = function (e) {
      if (!pending()) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      ask();
    };
    ['click', 'keydown'].forEach(function (t) { xp.addEventListener(t, block, true); });
  }

  sel.addEventListener('change', function () {
    if (sel.value === PH) return;
    form.removeAttribute('data-size-pending');
    sel.classList.remove('is-err');
    sel.removeAttribute('aria-invalid');
    sel.removeAttribute('aria-describedby');
    if (msg) { msg.remove(); msg = null; }
    if (catcher) { catcher.remove(); catcher = null; }
    if (xp) [].forEach.call(xp.children, function (c) { c.inert = false; });
  });
})();
/* [/sizepick-29sep] */

/* [msize-20oct] Ilyas 20 Oct: now that bracelets open with a size chosen, the sticky bar shows it next to the price
   ("£95 · Size M"). A <span> AFTER .m-price, never inside it, because paintVariant rewrites .m-price on every change.
   Follows the size select (bracelet Length, or a ring's gated select once a size is picked; nothing while the ring
   placeholder is showing). Styles in samedi-v2.css [msize-20oct]. To undo: delete this block and that one. */
(function () {
  var bar = document.querySelector('.mcart'), pr = bar && bar.querySelector('.m-price'), form = document.getElementById('atc-form');
  if (!pr || !form) return;
  var sel = form.querySelector('select[data-opt=length]') || form.querySelector('select[data-gate]');
  if (!sel || sel.options.length < 2) return;
  var tag = document.createElement('span');
  tag.className = 'm-size';
  pr.insertAdjacentElement('afterend', tag);
  function paint() {
    var o = sel.options[sel.selectedIndex];
    var t = (o && o.value !== '__pick') ? o.textContent.replace(/\s*\(.*$/, '').trim() : '';
    tag.textContent = t ? 'Size ' + t : '';
    tag.style.display = t ? '' : 'none';
  }
  paint();
  sel.addEventListener('change', function () { setTimeout(paint, 0); });
  window.addEventListener('pageshow', paint);
  setTimeout(paint, 700);
})();
/* [/msize-20oct] */
